import { Component, OnInit, Inject } from '@angular/core';
import { environment } from '@pg-env/environment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MyOutstandingAmountService } from '@pg-app/client/client-dashboard/components/my-outstanding-amount/my-outstanding-amount.service';
import { UtilityService } from '@nttp/common-service/utility-service';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';

@Component({
  selector: 'np-client-outstanding-trades',
  templateUrl: './client-outstanding-trades.component.html',
  styleUrls: ['./client-outstanding-trades.component.scss']
})
export class ClientOutstandingTradesComponent implements OnInit {
  public rows = [];
  public columns = [
      {
        title: 'Trade ref',
        name: 'tradeNo',
        width: '120px'
      },
      {
        title: 'Trade type',
        name: 'tradeType',
        width: '120px'
      },
      {
        title: 'Value date',
        name: 'valueDate',
        type: TableCellTypes.Date,
        width: '130px'
      },
      {
        title: 'Buy CCY',
        name: 'buyCurrency',
        width: '100px'
      },
      {
        title: 'Buy amount',
        name: 'buyAmount',
        type: TableCellTypes.Number,
        class: 'text-right',
        width: '150px'
      },
      {
        title: 'Sell CCY',
        name: 'sellCurrency',
        width: '100px'
      },
      {
        title: 'Sell amount',
        name: 'sellAmount',
        type: TableCellTypes.Number,
        class: 'text-right',
        width: '150px'
      }
    ];
  public totalItems = 0;

  constructor(
    public dialogRef: MatDialogRef<ClientOutstandingTradesComponent>,
    public myOutstandingAmountService: MyOutstandingAmountService,
    public utilityService: UtilityService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) { }

  ngOnInit() {
    this.getOutstandingTrades();
  }

  public getOutstandingTrades(paging = null) {
    const filters = paging?.filter && paging.filter.length > 0 ? paging.filter : null;
    const filterByTradeNumber = filters && filters.find(p => p.propertyName === 'TradeNo');
    if (filterByTradeNumber) {
      filterByTradeNumber.propertyName = 'Number';
    }

    const params = {
      currencyId: this.dialogData.currencyId,
      pageSize: environment.defaultPageSize,
      pageIndex: paging ? paging.currentPage : 1,
      sortName: paging?.sortName  || 'Number',
      sortType: paging?.sortName ? paging.sortType : 1,
      filters: filters || null
    };
    this.myOutstandingAmountService.getOutstandingTrade(params).subscribe(
      data => {
        this.rows = data.trades || [];
        this.totalItems = data.pagination.totalItems;
      }
    );
  }
}
